// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xItv","newExpiryDate":"styles_newExpiryDate__2evpq","footer":"styles_footer__2Bhpt"};